import React from "react";
import { ImageProps } from "@chakra-ui/image/dist/types/image";

import { getFileUrl } from "utils/getFileUrl";

import { CustomLogo } from "./CustomLogo";
import { DefaultLogo } from "./DefaultLogo";

interface IProps extends ImageProps {
  logoFileId?: number;
}

const Logo = ({ logoFileId, ...restProps }: IProps) => {
  const logoTestId = "main-logo";
  return (
    <>
      {logoFileId ? (
        <CustomLogo
          logoUrl={getFileUrl(logoFileId)}
          id={logoTestId}
          {...restProps}
        />
      ) : (
        <DefaultLogo id={logoTestId} />
      )}
    </>
  );
};

export { Logo };
